import script from "./Community.vue?vue&type=script&setup=true&lang=js"
export * from "./Community.vue?vue&type=script&setup=true&lang=js"

import "./Community.vue?vue&type=style&index=0&id=5f3ba90c&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f3ba90c"]])

export default __exports__